$('.button_next_step').on('click', function() {
    var activeStep = $(this).parents('.mt_step_container');
    var lastActiveStep = $('.mt_steps_bar .mt_step_active').last();
    activeStep.removeClass('mt_show').addClass('mt_hide');
    activeStep.next('.mt_step_container').removeClass('mt_hide').addClass('mt_show');
    lastActiveStep.next('.mt_step_block').addClass('mt_step_active');
});